import type { FC } from "react";
import React from "react";
import { DfpUserConfirm } from "../../data_blocks/dfp_user_confirm";

export const DfpUserConfirmPage: FC = () => <DfpUserConfirm />;
